import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "@/hooks/useAuth";
import { SystemHealthProvider } from "@/hooks/useSystemHealth";
import "./index.css";
import { registerSW } from "virtual:pwa-register";

// PWA: Service Worker hält die App-Shell (JS/CSS/Fonts/Icons) offline vor,
// die API bleibt Network-only (siehe vite.config.ts). `autoUpdate` aktiviert
// eine neue Version beim nächsten Laden von selbst — kein Reload-Dialog nötig.
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SystemHealthProvider>
          <App />
        </SystemHealthProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
